import type {AxiosRequestConfig} from 'axios';
// import {Bundle, Status, CancelBundle} from './interface';

export class GetAllPaymentsRequestBuilder {
  private readonly paymentRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/payments',
    params: {},
  };
  params(params: object) {
    this.paymentRequest.params = params;
    return this;
  }
  build() {
    return this.paymentRequest;
  }
}
export class GetPaymentRequestBuilder {
  private readonly paymentRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
    params: {},
  };
  params(params: object) {
    this.paymentRequest.params = params;
    return this;
  }

  id(id: number) {
    this.paymentRequest.url = `/payments/${id}`;
    return this;
  }
  build() {
    return this.paymentRequest;
  }
}
export class GetPaymentsCountRequestBuilder {
  private readonly paymentRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/payments/count',
  };
  params(params: object) {
    this.paymentRequest.params = params;
    return this;
  }
  build() {
    return this.paymentRequest;
  }
}


export class ToPayRequestBuilder {
  private readonly paymentRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '',
    params: {},
  };

  id(id: number) {
    this.paymentRequest.url = `/payments/${id}`;
    return this;
  }
  // params(params: object) {
  //   this.paymentRequest.params = params;
  //   return this;
  // }
  build() {
    return this.paymentRequest;
  }
}






// export class UploadBundlesRequestBuilder {
//   private readonly uploadProductsReq: AxiosRequestConfig = {
//     method: 'POST',
//     url: '/bundles/uploadFile',
//     data: {},
//   };

//   data(body: any) {
//     this.uploadProductsReq.data = body;
//     return this;
//   }

//   build() {
//     return this.uploadProductsReq;
//   }
// }
